import { datadogLogs } from '@datadog/browser-logs';
import {
  fetchPostUserConsent,
  PostUserConsentRequestBody,
} from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

const MUTATION_KEY = 'company_questions_signup_ai';

export function useUserConsentMutation() {
  const { mutateAsync } = useMutation({
    mutationFn: async ({
      body,
      provider,
      stateKey,
    }: {
      body: PostUserConsentRequestBody;
      provider: string;
      stateKey: string;
    }) => {
      await fetchPostUserConsent({
        body,
        provider,
        stateKey,
      });
    },
    mutationKey: [MUTATION_KEY],
    onError: (error) => {
      datadogLogs.logger.error(
        'User consent failed to save',
        { viteBuildHash },
        error as Error,
      );
    },
  });

  return {
    postUserConsent: mutateAsync,
  };
}
